import PropTypes from 'prop-types';
import logo from 'assets/images/groceryLogo.png';

// ==============================|| LOGO SVG ||============================== //

const LogoMain = () => {
  return (
    <img src={logo} alt="icon logo" style={{width:'110px', marginTop:'25px'}} />
  );
};

LogoMain.propTypes = {
  reverse: PropTypes.bool
};

export default LogoMain;
